(function () {
  'use strict';

  /* global $ */
  $.AdminLTE.options.enableBSToppltip = false;

  angular
    .module('corePermissoes')
    .run(setBlockUIMessage);

  function setBlockUIMessage($translate, blockUIConfig) {
    blockUIConfig.requestFilter = function (blockConfig) {
      if (blockConfig.url.match(/alertas\/quantidade/)) {
        return false;
      }
      return $translate.isReady() ? $translate.instant('ce.common.carregando') : 'Carregando...';
    };
  }
  setBlockUIMessage.$inject = ['$translate', 'blockUIConfig'];
}());
